export enum APPOINTMENT_SCHEDULE_PAYMENT_PREFERENCE {
  NONE = 'none',
  CARD_ON_FILE = 'cardOnFile',
  OPTIONAL_CARD_ON_FILE = 'optionalCardOnFile',
}
